import GoogleMapComponent from "./GoogleMap";

export default GoogleMapComponent;
